import { useTranslation } from 'react-i18next'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import { Root, Marker, Label } from './Status.styled'

const { Typography } = common

export enum StatusProgress {
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  ToDo = 'TO_DO',
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Renew = 'RENEW',
}

export type StatusProps = {
  progress?: StatusProgress
  mode?: Mode
  title?: string
  dataTest?: string
}

export const getStatusProgress = (isCompleted?: boolean): StatusProgress | undefined => {
  if (isCompleted === undefined) return
  return isCompleted ? StatusProgress.Completed : StatusProgress.InProgress
}

export const getFullStatusProgress = (
  isCompleted?: boolean,
  inProgress?: boolean,
  isExpired?: boolean
): StatusProgress => {
  if (isCompleted) return StatusProgress.Completed
  if (inProgress) return StatusProgress.InProgress
  if (isExpired) return StatusProgress.Renew
  return StatusProgress.ToDo
}

const Status: React.FC<StatusProps> = props => {
  const { progress, mode, title, dataTest } = props
  const { t } = useTranslation()

  function getProgressTitle() {
    if (title) return title
    switch (progress) {
      case StatusProgress.Completed:
        return t('statuses.completed')
      case StatusProgress.ToDo:
        return t('statuses.toDo')
      case StatusProgress.Active:
        return t('statuses.active')
      case StatusProgress.Inactive:
        return t('statuses.inactive')
      case StatusProgress.InProgress:
        return t('statuses.inProgress')
      case StatusProgress.Renew:
        return t('statuses.renew')

      default:
        return t('statuses.inProgress')
    }
  }

  if (progress === undefined) return null

  return (
    <Root mode={mode} data-test={dataTest}>
      <Marker status={progress} data-test='StatusMarker' />
      <Label>
        <Typography variant='h4' dataTest='StatusTitle'>
          {getProgressTitle()}
        </Typography>
      </Label>
    </Root>
  )
}

export default Status
